import { useCallback } from 'react';

import { Container, LeftSection, RightSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';
import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import ProfileLoading from '@/_pages/inventories/profile/loading';
import { ProfileRightSectionLoading } from '@/_pages/inventories/profile/right-section';
import { HeaderLoading } from '@/_pages/inventories/shared/components/header-section';
import VendorsLoading from '@/_pages/inventories/vendors/loading';
import { inventorySubNav, useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();
  const { tabKey, renderRightColumn } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'inventory/vendors':
        return <VendorsLoading />;
      case 'inventory/profile':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return (
    <SecondaryPageLayoutLoading subNavLinks={inventorySubNav}>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection>
          <HeaderLoading />

          {render()}
        </LeftSection>
        {renderRightColumn && (
          <RightSection>
            <ProfileRightSectionLoading />
          </RightSection>
        )}
      </Container>
    </SecondaryPageLayoutLoading>
  );
}
